import { CollapsibleNotesGroup } from '@/components/CollapsibleNoteGroup';
import { CollapsibleTaskGroup } from '@/components/CollapsibleTaskGroup';
import { usePreviewMode } from '@/hooks/usePreviewMode';
import { taskSearch } from '@/utils/typesense/clients/taskSearch';
import { Grid } from '@mui/material';
import React from 'react';
import { InstantSearch } from 'react-instantsearch';

const ActivitiesContent = () => {
	const { previewId } = usePreviewMode();
	return (
		<React.Fragment key={previewId}>
			<Grid size={12}>
				<CollapsibleNotesGroup />
			</Grid>

			<Grid size={12}>
				<InstantSearch searchClient={taskSearch} indexName='tasks'>
					<CollapsibleTaskGroup displayCard={false} />
				</InstantSearch>
			</Grid>
		</React.Fragment>
	);
};
ActivitiesContent.displayName = 'ActivitiesContent';
export default ActivitiesContent;
